export enum ERROR_CODES {
  TOO_MANY_REQUESTS = 429,
  INTERNAL_ERROR = 500,
}
